/**
 * General functions.
 */
export default function general () {
    
  resizeMobileNav()
  window.addEventListener( 'resize', debounce( resizeMobileNav ), 250 )
}

/**
 * Reisze nave menu height.
 */
function resizeMobileNav () {
  // Set the value in the --vh custom property to the root of the document.
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty( '--vh', `${vh}px` )
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not be triggered.
 * The function will be called after it stops being called for N milliseconds.
 * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
 * Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)
 *
 * @param {function} func Function to debounce.
 * @param {int} wait Milliseconds to wait.
 * @param {bool} immediate Call on leading or trailing.
 * @returns {fucntion} Debounced function.
 */
function debounce ( func, wait, immediate ) {
  let timeout

  return function executedFunction () {
    const context = this
    const args = arguments

    const later = function laterFn() {
      timeout = null
      if ( !immediate ) {
        func.apply( context, args )
      }
    }

    const callNow = immediate && !timeout

    clearTimeout( timeout )

    timeout = setTimeout( later, wait )
	
    if ( callNow ) {
      func.apply( context, args )
    }
  }
}